import React from "react";
import { createPortal } from "react-dom";
import Close from "../assets/images/X.svg";
import Button from "./Button";
import { useNavigate } from "react-router-dom";

const CenteredToast = ({ message, onClose, isClosable = false }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!isClosable) {
      const timeout = setTimeout(onClose, 4000); // Auto-dismiss after 8 seconds only when not closable
      return () => clearTimeout(timeout);
    }
  }, [onClose, isClosable]);

  return createPortal(
    <div className="leap-fixed leap-inset-0 leap-flex leap-items-center leap-justify-center leap-z-[9999] leap-bg-black/40">
      <div
        className="leap-relative leap-bg-[#212053] leap-text-white 
        leap-shadow-xl leap-w-[40%] max-xl:leap-w-[80%] leap-px-8 leap-py-6 leap-text-center leap-rounded-2xl 
        leap-font-semibold leap-text-xl leap-flex leap-flex-col leap-items-center leap-gap-2  leap-border-2 leap-border-[#EB3DF7]"
      >
        {/* Message */}
        <p className="!leap-text-base lg:!leap-text-lg leap-py-6">{message}</p>

        {/* Close Button and Additional Content */}
        {isClosable && (
          <>
            <button
              onClick={onClose}
              className="leap-absolute leap-top-3 leap-right-3 leap-text-white leap-bg-transparent leap-text-2xl hover:leap-text-[#EB3DF7] focus:leap-outline-none"
            >
              <img
                src={Close}
                alt="Close"
                className="leap-top-[20px] leap-left-[25px]"
                loading="lazy"
              />
            </button>

            {/* Booked Tours Button */}
            <div>
              <Button
                text="Booked tours"
                bgColor="transparent"
                textColor="#73FAFD"
                customStyles="!leap-text-base lg:!leap-text-lg leap-uppercase leap-border-2 leap-border-solid leap-border-[#73FAFD]"
                onClick={() => navigate("/personal-page")}
              />
            </div>
          </>
        )}
      </div>
    </div>,
    document.body
  );
};

export default CenteredToast;
